import Vue from 'vue'
import { canUseWebP, imageIsExist } from 'fe-common'

Vue.directive('o-img', async function(el, binding) {
  const originImageUrl = binding.value
  const optimizeImageUrl =
    binding.value
      .split('.')
      .slice(0, -1)
      .join('.') + '.webp'

  let exist = false
  if (canUseWebP()) {
    exist = await imageIsExist(optimizeImageUrl)
  }
  el.setAttribute('src', exist ? optimizeImageUrl : originImageUrl)
})
